export function getEnvName() {
  if (isDev()) return 'development';
  if (isTest()) return 'test';
  return 'production';
}

export function getEnvBranch() {
  if (isRuntime()) {
    return useRuntimeConfig().public.branch;
  }
  return process.env.BRANCH;
}

export function isDev() {
  if (isRuntime()) {
    return useRuntimeConfig().public.isDev;
  }
  return process.env.NODE_ENV == 'development' || !!process.env.IS_DEV;
}

export function isTest() {
  if (isRuntime()) {
    return useRuntimeConfig().public.isTest;
  }
  return !!process.env.IS_TEST;
}

export function getMongoUri() {
  if (isRuntime()) {
    return useRuntimeConfig().mongodbUri;
  }
  return process.env.MONGODB_URI;
}

function isRuntime() {
  return typeof useRuntimeConfig == 'function';
}